var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'AutoMarketingList'
      }
    }
  }, [_vm._v("行銷自動化 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "查看行銷自動化" : _vm.isEdit ? "編輯行銷自動化" : "新增行銷自動化") + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看行銷自動化" : _vm.isEdit ? "編輯行銷自動化" : "新增行銷自動化") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, [_c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-1",
      modifiers: {
        "accordion-1": true
      }
    }],
    staticClass: "text-left",
    attrs: {
      "block": "",
      "variant": "primary"
    }
  }, [_vm._v("基本設定")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-1",
      "visible": "",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', {
    staticClass: "py-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路",
      "label-for": "merchant"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants || _vm.isReadOnly
    },
    model: {
      value: _vm.form.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "merchant_id", $$v);
      },
      expression: "form.merchant_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.merchant_id.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.title.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用期間"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "disabledDates": _vm.disabledDates,
      "clear-button": "",
      "input-class": _vm.v$.form.start_at.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "start_at", $$v);
      },
      expression: "form.start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "disabledDates": _vm.disabledDates,
      "clear-button": "",
      "input-class": _vm.v$.form.end_at.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "end_at", $$v);
      },
      expression: "form.end_at"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "類型"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.type.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.type.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.is_enabled.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_enabled", $$v);
      },
      expression: "form.is_enabled"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.is_enabled.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "細節設定"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.config.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "config", $$v);
      },
      expression: "form.config"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.config.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-2",
      modifiers: {
        "accordion-2": true
      }
    }],
    staticClass: "text-left",
    attrs: {
      "block": "",
      "variant": "primary"
    }
  }, [_vm._v("觸發事件")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-2",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', {
    staticClass: "d-flex"
  }, [_c('b-form-select', {
    staticClass: "w-auto mr-4 bg-primary text-white",
    attrs: {
      "options": _vm.triggers.map(function (x) {
        return {
          value: x,
          text: x.text
        };
      }),
      "value": _vm.triggers[0]
    },
    on: {
      "change": _vm.triggerChange
    }
  }), _vm.form.trigger.type ? _c('div', {
    staticClass: "flex-fill"
  }, [_vm.form.trigger.type == 'birthday' ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "thatDay"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'thatDay'
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 當天 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "thatMonth"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'thatMonth',
          thatMonth: 1
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 當月 "), _c('div', [_c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'thatMonth',
      "state": _vm.v$.form.trigger['thatMonth'] && _vm.v$.form.trigger['thatMonth'].$error ? false : null,
      "min": "1",
      "max": "31"
    },
    model: {
      value: _vm.form.trigger['thatMonth'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'thatMonth', _vm._n($$v));
      },
      expression: "form.trigger['thatMonth']"
    }
  }), _vm._v(" 日 ")], 1)], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "lastMonth"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'lastMonth',
          lastMonth: 1
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 前一個月 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'lastMonth',
      "state": _vm.v$.form.trigger['lastMonth'] && _vm.v$.form.trigger['lastMonth'].$error ? false : null,
      "min": "1",
      "max": "12"
    },
    model: {
      value: _vm.form.trigger['lastMonth'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'lastMonth', _vm._n($$v));
      },
      expression: "form.trigger['lastMonth']"
    }
  }), _vm._v(" 日 ")], 1)] : _vm.form.trigger.type == 'checkin' ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_vm._v(" 連續 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1",
      "state": _vm.v$.form.trigger['continuous'] && _vm.v$.form.trigger['continuous'].$error ? false : null
    },
    model: {
      value: _vm.form.trigger['continuous'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'continuous', _vm._n($$v));
      },
      expression: "form.trigger['continuous']"
    }
  }), _vm._v(" 天 ")], 1)] : _vm.form.trigger.type == 'login' ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1",
      "state": _vm.v$.form.trigger['frequency'] && _vm.v$.form.trigger['frequency'].$error ? false : null
    },
    model: {
      value: _vm.form.trigger['frequency'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'frequency', _vm._n($$v));
      },
      expression: "form.trigger['frequency']"
    }
  }), _vm._v(" 次 ")], 1)] : _vm.form.trigger.type == 'special-login' ? [_c('div', {
    staticClass: "form-inline mb-2 d-flex flex-nowrap"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "dateRange"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'dateRange',
          dateRange: {
            from: new Date(),
            to: new Date()
          },
          timeRange: {
            from: {
              HH: null,
              mm: null
            },
            to: {
              HH: null,
              mm: null
            }
          }
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('div', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.form.trigger.value != 'dateRange',
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger['dateRange'].from && _vm.v$.form.trigger['dateRange'].from.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.dateRange.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.dateRange, "from", $$v);
      },
      expression: "form.trigger.dateRange.from"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabled": _vm.form.trigger.value != 'dateRange',
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger['dateRange'].to && _vm.v$.form.trigger['dateRange'].to.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.dateRange.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.dateRange, "to", $$v);
      },
      expression: "form.trigger.dateRange.to"
    }
  })], 1), _c('b-form-invalid-feedback', {
    staticClass: "w-100",
    attrs: {
      "state": _vm.v$.form.trigger['dateRange'].beforeEndAt && !_vm.v$.form.trigger.dateRange.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1)], 1), _c('div', {
    staticClass: "form-inline mb-2 d-flex flex-nowrap"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "timeRange"
    },
    on: {
      "change": function change() {
        _vm.form.trigger = {
          type: _vm.form.trigger.type,
          value: 'timeRange',
          dateRange: {
            from: new Date(),
            to: new Date()
          },
          timeRange: {
            from: {
              HH: null,
              mm: null
            },
            to: {
              HH: null,
              mm: null
            }
          }
        };
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('div', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.form.trigger.value != 'timeRange',
      "input-class": ['form-control', _vm.v$.form.trigger['timeRange'].from && (_vm.v$.form.trigger['timeRange'].from.HH.$error || _vm.v$.form.trigger['timeRange'].from.mm.$error) ? 'is-invalid' : '']
    },
    model: {
      value: _vm.form.trigger.timeRange.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.timeRange, "from", $$v);
      },
      expression: "form.trigger.timeRange.from"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "disabled": _vm.form.trigger.value != 'timeRange',
      "input-class": ['form-control', _vm.v$.form.trigger['timeRange'].to && (_vm.v$.form.trigger['timeRange'].to.HH.$error || _vm.v$.form.trigger['timeRange'].to.mm.$error) ? 'is-invalid' : '']
    },
    model: {
      value: _vm.form.trigger.timeRange.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger.timeRange, "to", $$v);
      },
      expression: "form.trigger.timeRange.to"
    }
  })], 1), _c('b-form-invalid-feedback', {
    staticClass: "w-100",
    attrs: {
      "state": _vm.v$.form.trigger.timeRange.beforeEndAt && !_vm.v$.form.trigger.timeRange.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1)], 1)] : _vm._e(), ['purchase', 'month-purchase', 'range-purchase'].includes(_vm.form.trigger.type) ? [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_vm.form.trigger.type == 'range-purchase' ? _c('div', {
    staticClass: "d-flex flex-column flex-xl-row align-items-start align-items-xl-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger.from && _vm.v$.form.trigger.from.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.from,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "from", $$v);
      },
      expression: "form.trigger.from"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "clear-button": "",
      "disabledDates": _vm.disabledDates,
      "input-class": _vm.v$.form.trigger.to && _vm.v$.form.trigger.to.$error ? 'is-invalid' : ''
    },
    model: {
      value: _vm.form.trigger.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "to", $$v);
      },
      expression: "form.trigger.to"
    }
  })], 1) : _vm._e(), _c('b-form-invalid-feedback', {
    staticClass: "w-100",
    attrs: {
      "state": _vm.v$.form.trigger.from.beforeEndAt && !_vm.v$.form.trigger.from.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "frequency"
    },
    on: {
      "change": function change() {
        var v = {
          type: _vm.form.trigger.type,
          value: 'frequency',
          frequency: 1
        };
        if (v.type == 'range-purchase') {
          v.from = _vm.form.trigger.from;
          v.to = _vm.form.trigger.to;
        }
        _vm.form.trigger = v;
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'frequency',
      "min": "1",
      "state": _vm.v$.form.trigger.frequency && _vm.v$.form.trigger.frequency.$error ? false : null
    },
    model: {
      value: _vm.form.trigger['frequency'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'frequency', _vm._n($$v));
      },
      expression: "form.trigger['frequency']"
    }
  }), _vm._v(" 次 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "item"
    },
    on: {
      "change": function change() {
        var v = {
          type: _vm.form.trigger.type,
          value: 'item',
          item: 1
        };
        if (v.type == 'range-purchase') {
          v.from = _vm.form.trigger.from;
          v.to = _vm.form.trigger.to;
        }
        _vm.form.trigger = v;
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'item',
      "min": "1",
      "state": _vm.v$.form.trigger.item && _vm.v$.form.trigger.item.$error ? false : null
    },
    model: {
      value: _vm.form.trigger['item'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'item', _vm._n($$v));
      },
      expression: "form.trigger['item']"
    }
  }), _vm._v(" 項商品 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "amount"
    },
    on: {
      "change": function change() {
        var v = {
          type: _vm.form.trigger.type,
          value: 'amount',
          amount: 1
        };
        if (v.type == 'range-purchase') {
          v.from = _vm.form.trigger.from;
          v.to = _vm.form.trigger.to;
        }
        _vm.form.trigger = v;
      }
    },
    model: {
      value: _vm.form.trigger.value,
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, "value", $$v);
      },
      expression: "form.trigger.value"
    }
  }), _vm._v(" 滿 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.trigger.value != 'amount',
      "min": "1",
      "state": _vm.v$.form.trigger.amount && _vm.v$.form.trigger.amount.$error ? false : null
    },
    model: {
      value: _vm.form.trigger['amount'],
      callback: function callback($$v) {
        _vm.$set(_vm.form.trigger, 'amount', _vm._n($$v));
      },
      expression: "form.trigger['amount']"
    }
  }), _vm._v(" 金額 ")], 1)] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-0",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.accordion-3",
      modifiers: {
        "accordion-3": true
      }
    }],
    staticClass: "text-left",
    attrs: {
      "block": "",
      "variant": "primary"
    }
  }, [_vm._v("回應內容")])], 1), _c('b-collapse', {
    attrs: {
      "id": "accordion-3",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', {
    staticClass: "py-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "貼標"
    }
  }, [_c('div', {
    staticClass: "border rounded p-1"
  }, [_vm._l(_vm.form.response.tags, function (tag, idx) {
    return _c('b-badge', {
      key: idx,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(tag) + " "), _c('button', {
      staticClass: "btn btn-xs p-0",
      on: {
        "click": function click($event) {
          return _vm.form.response.tags.splice(idx, 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "placeholder": "輸入標籤"
    },
    on: {
      "keyup": function keyup(e) {
        var v = null;
        if (e.key == ',') {
          v = e.target.value.slice(0, -1);
        } else if (e.key == 'Enter') {
          v = e.target.value;
        }
        if (v && !_vm.form.response.tags.includes(v)) {
          _vm.form.response.tags.push(v);
          e.target.value = '';
        }
      }
    }
  })], 2)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放優惠卷"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    model: {
      value: _vm.form.response.coupon.id,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.coupon, "id", $$v);
      },
      expression: "form.response.coupon.id"
    }
  }), _c('b-form-checkbox', {
    model: {
      value: _vm.form.response.coupon.limite,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.coupon, "limite", $$v);
      },
      expression: "form.response.coupon.limite"
    }
  }, [_vm._v("每人限定一張")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放徽章"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    model: {
      value: _vm.form.response.badge.id,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.badge, "id", $$v);
      },
      expression: "form.response.badge.id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發放點數"
    }
  }, [_c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "fixed"
    },
    on: {
      "change": function change() {
        _vm.form.response.point = {
          type: 'fixed',
          point: 1
        };
      }
    },
    model: {
      value: _vm.form.response.point.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "type", $$v);
      },
      expression: "form.response.point.type"
    }
  }), _vm._v(" 固定點數 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.response.point.type != 'fixed',
      "min": "1",
      "state": _vm.v$.form.response.point.point && _vm.v$.form.response.point.point.$error ? false : null
    },
    model: {
      value: _vm.form.response.point.point,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "point", _vm._n($$v));
      },
      expression: "form.response.point.point"
    }
  }), _vm._v(" 點 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "multiple"
    },
    on: {
      "change": function change() {
        _vm.form.response.point = {
          type: 'multiple',
          multiple: 1
        };
      }
    },
    model: {
      value: _vm.form.response.point.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "type", $$v);
      },
      expression: "form.response.point.type"
    }
  }), _vm._v(" 訂單金額 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.response.point.type != 'multiple',
      "min": "1",
      "state": _vm.v$.form.response.point.multiple && _vm.v$.form.response.point.multiple.$error ? false : null
    },
    model: {
      value: _vm.form.response.point.multiple,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "multiple", _vm._n($$v));
      },
      expression: "form.response.point.multiple"
    }
  }), _vm._v(" 倍點數 ")], 1), _c('div', {
    staticClass: "form-inline mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "level"
    },
    on: {
      "change": function change() {
        _vm.form.response.point = {
          type: 'level',
          levelAmount: 1,
          levelPoint: 1
        };
      }
    },
    model: {
      value: _vm.form.response.point.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "type", $$v);
      },
      expression: "form.response.point.type"
    }
  }), _vm._v(" 每 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.response.point.type != 'level',
      "min": "1",
      "state": _vm.v$.form.response.point.levelAmount && _vm.v$.form.response.point.levelAmount.$error ? false : null
    },
    model: {
      value: _vm.form.response.point.levelAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "levelAmount", _vm._n($$v));
      },
      expression: "form.response.point.levelAmount"
    }
  }), _vm._v(" 贈 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "disabled": _vm.form.response.point.type != 'level',
      "min": "1",
      "state": _vm.v$.form.response.point.levelPoint && _vm.v$.form.response.point.levelPoint.$error ? false : null
    },
    model: {
      value: _vm.form.response.point.levelPoint,
      callback: function callback($$v) {
        _vm.$set(_vm.form.response.point, "levelPoint", _vm._n($$v));
      },
      expression: "form.response.point.levelPoint"
    }
  }), _vm._v(" 點 ")], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "發送推播"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goListPage
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }